module.exports = __webpack_public_path__ + "static/img/logo8.d7355952.jpg";